<template>
  <div>
    <CCard v-if="show">
      <CCardHeader>
        <CIcon name="cil-pencil"/>
        <strong> Marketing e Análise </strong>
        <div class="card-header-actions">
          <CLink
            class="card-header-action btn-minimize"
            @click="collapsed = !collapsed">
            <CIcon :name="`cil-chevron-${collapsed ? 'top' : 'bottom'}`"/>
          </CLink>
        </div>
      </CCardHeader>
      <CCollapse :show="collapsed">
        <CCardBody>
          <validation-observer ref="observer" v-slot="{ invalid }">
            <CForm>
              <CRow>
                <CCol sm="6">
                  <validation-provider
                    name="pixel do Facebook"
                    rules="required|min:15"
                    v-slot="{ errors, valid, touched }"
                  >
                    <CInput
                      valid-feedback
                      label="Pixel Facebook"
                      placeholder="000000000000000"
                      :invalid-feedback="errors[0]"
                      v-model="form.pixel_facebook"
                      :is-valid="touched == false ? null : valid ? true : false"
                    />
                  </validation-provider>
                </CCol>
                <CCol sm="6">
                  <validation-provider
                    name="ID Google Analytics"
                    rules="required|min:11"
                    v-slot="{ errors, valid, touched }"
                  >
                    <CInput
                      valid-feedback
                      label="ID Google Analytics"
                      :invalid-feedback="errors[0]"
                      placeholder="UA-12345678-9"
                      v-mask="'AA-########-#'"
                      v-model="form.google_analytics"
                      :is-valid="touched == false ? null : valid ? true : false"
                    />
                  </validation-provider>
                </CCol>
              </CRow>
              <CRow class="border-top">
                <CCol class="text-right">
                  <div class="mt-2">
                    <CButton
                      v-if="form.id"
                      class="mr-2"  
                      type="submit" 
                      color="success"
                      :disabled="invalid"
                      @click.prevent="update()">
                      Atualizar
                    </CButton>
                    <CButton
                      v-else
                      type="submit" 
                      color="primary"
                      :disabled="invalid"
                      @click.prevent="save()">
                      Enviar
                    </CButton>
                  </div>
                </CCol>
              </CRow>
            </CForm>
          </validation-observer>
        </CCardBody>
      </CCollapse>
    </CCard>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  export default {
    name: 'marketingForm',
    props: {
      show: {
        type: Boolean,
        required: true
      }
    },
    computed: {
      form: {
        get() {
          return this.$store.state.marketing
        }
      },
      collapsed: {
        get() { 
          return this.$store.state.forms.collapsed.marketing 
        },
        set() {
          this.$store.commit('setCollapsedTrue', 'marketing')
        }
      }
    },
    methods: {
      ...mapActions(['saveMarketing', 'updateMarketing']),
      save() {
        this.saveMarketing(this.form);
      },
      update() {
        this.updateMarketing(this.form)
      }
    }
  }
</script>
